import styled from "styled-components";

import { FlexDiv, FlexSection } from "../../../components/Atoms";
import Typography from "../../../foundation/Typography/V2";
import theme from "../../../foundation/Theme";

export const NutritionistVideoWrapper = styled(FlexSection)`
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 80px 16px;
  &:before {
    content: "";
    background-color: ${theme?.colorsV2?.shyft?.blue};
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 65%;
    z-index: -1;
    opacity: 0.2;
    @media only screen and (max-width: 767px) {
      height: 100%;
    }
  }
  @media only screen and (max-width: 767px) {
    padding: 48px 16px;
  }
`;

export const Title = styled(Typography)`
  margin: 0 0 24px;
`;

export const SubTitle = styled(Typography)`
  margin: 0 0 48px;
  max-width: 750px;
  text-align: center;
  @media only screen and (max-width: 767px) {
    margin: 0 0 24px;
  }
`;

export const YoutubeContainer = styled(FlexDiv)`
  width: 728px;
  height: 400px;
  background-color: ${({ theme }) => theme.colors.black};
  border-radius: 50px;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 10px 65px 0px #1d485763;
  margin: 0 0 40px;
  .videoOverlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    &:after {
      background-color: rgba(${({ theme }) => theme.colors.shadows.black}, 0.7);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      content: "";
      pointer-events: none;
    }
  }
  @media only screen and (max-width: 1100px) {
    width: 100%;
    height: 400px;
  }
  @media only screen and (max-width: 767px) {
    border-radius: 20px;
    height: 220px;
    margin: 0 0 32px;
  }
`;
